// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
// State represent the various states of a transcription
// Modify cautiously as this mapping is critical for the
// correct functioning of the transcription states
export var State;
(function (State) {
    State["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    State["STATE_UNSUBMITTED"] = "STATE_UNSUBMITTED";
    State["STATE_IN_PROGRESS"] = "STATE_IN_PROGRESS";
    State["STATE_HAS_CONTENT"] = "STATE_HAS_CONTENT";
    State["STATE_NO_CONTENT"] = "STATE_NO_CONTENT";
    State["STATE_FAILED"] = "STATE_FAILED";
    State["STATE_LOW_CONFIDENCE"] = "STATE_LOW_CONFIDENCE";
    State["STATE_UNAVAILABLE"] = "STATE_UNAVAILABLE";
})(State || (State = {}));
export var State_index;
(function (State_index) {
    State_index[State_index["STATE_UNSPECIFIED"] = 0] = "STATE_UNSPECIFIED";
    State_index[State_index["STATE_UNSUBMITTED"] = 1] = "STATE_UNSUBMITTED";
    State_index[State_index["STATE_IN_PROGRESS"] = 2] = "STATE_IN_PROGRESS";
    State_index[State_index["STATE_HAS_CONTENT"] = 3] = "STATE_HAS_CONTENT";
    State_index[State_index["STATE_NO_CONTENT"] = 4] = "STATE_NO_CONTENT";
    State_index[State_index["STATE_FAILED"] = 5] = "STATE_FAILED";
    State_index[State_index["STATE_LOW_CONFIDENCE"] = 6] = "STATE_LOW_CONFIDENCE";
    State_index[State_index["STATE_UNAVAILABLE"] = 7] = "STATE_UNAVAILABLE";
})(State_index || (State_index = {}));
